import Div from "@jumbo/shared/Div/Div";
import {fetchApplicationType, fetchEntityStatus, fetchMatterStatus, fetchMatterSubMatterType} from "app/utils/constants/fetchMappingData";
import {useEffect, useState} from "react";
import {get} from "../../../common/network";
import {formatDate} from "../../../constants/date_format";
import FormPreloader from "../../../utils/FormLoader";

const MatterDetailsTab = ({isMatterDetails, isLoading}) => {

    const [countriesMapping, setCountriesMapping] = useState([]);

    const fetchCountryData = async () => {
        const data = await get("docgen/countries");
        setCountriesMapping(data);
    };

    useEffect(() => {
        fetchMatterStatus();
        fetchApplicationType();
        fetchMatterSubMatterType();
        fetchEntityStatus();
        fetchCountryData();
    }, []);

    return (
        <Div>
            {isLoading ? (<FormPreloader/>) : (
                <div className="container-fluid">
                    <h6 className="form-sub-heading mb-3">Bibliographic</h6>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Attorney Docket Number</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.host_file_number}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Application Number</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.application_number}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row mb-3">
                                <div className="col-lg-2 col-md-4">
                                    <label className="label-x">Title</label>
                                </div>
                                <div className="col-lg-10 col-md-8">
                                    <div className="value-x">
                                        <div className="form-control">{isMatterDetails?.title}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Filing Date</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.filing_date
                                                ? formatDate(isMatterDetails?.filing_date, true)
                                                : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Local Filing Date</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.local_filing_date
                                                ? formatDate(isMatterDetails?.local_filing_date, true)
                                                : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Publication Number</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.publicationNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Publication Date</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.publicationDate
                                                ? formatDate(isMatterDetails?.publicationDate, true)
                                                : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Client Reference Number</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.clientReferenceNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Agent Reference Number</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.agentReferenceNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Confirmation Number</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.confirmation_number}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Art Unit</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.art_unit}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-4">
                                    <label className="label-x">Patent Number</label>
                                </div>
                                <div className="col-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.patent_number}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Issued Date</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.grant_date
                                                ? formatDate(isMatterDetails?.grant_date, true)
                                                : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Application Type</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.matter_sub_matter_type}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Subject Matter</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.matter_type}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Status</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.status}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Entity Status</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.matter_entity_size}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">
                                        Country
                                    </label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.country?.name || ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Deposit Account No.</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.deposit_acc_no}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Customer Number</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.correspondence_customer_no}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Expiry Date</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">{isMatterDetails?.expiryDate ? formatDate(isMatterDetails?.expiryDate, true) : ""}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-100"></div>
                        <div className="col-lg-6">
                            <div className="row mb-3 mt-4">
                                <div className="col-lg-4">
                                    <label className="label-x">PCT Application No</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.pct_application_no}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">PCT Filing Date</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.pct_date ? formatDate(isMatterDetails?.pct_date, true) : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">
                                        Priority Application Claimed
                                    </label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.priority_application_number}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Priority Date Claimed</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.priority_date ? formatDate(isMatterDetails?.priority_date, true) : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-lg-4">
                                    <label className="label-x">Last Updated At</label>
                                </div>
                                <div className="col-lg-8">
                                    <div className="value-x">
                                        <div className="form-control">
                                            {isMatterDetails?.updated_at ? formatDate(isMatterDetails?.updated_at) : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Div>
    );
};


export default MatterDetailsTab;